import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getPropertyDetails } from '../../../../api/services/hostService';
import { Button, CircularProgress, Typography } from '@mui/material';
import { useUserContext } from '../../../protectedRoute/UserContext';
import PostLoginHeader from '../../../../components/PostLoginHeader/PostLogin';

interface PropertyDetails {
  id: string;
  name: string;
  is_verified: boolean;
  // Add other property fields as needed
}

const HostPropertyDetails: React.FC = () => {
  const { property_id } = useParams<{ property_id: string }>();
  const [property, setProperty] = useState<PropertyDetails | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { state } = useUserContext();

  useEffect(() => {
    const fetchPropertyDetails = async () => {
      if (property_id) {
        try {
          const response = await getPropertyDetails(property_id);
          setProperty(response);
        } catch (error) {
          console.error('Error fetching property details:', error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchPropertyDetails();
  }, [property_id]);

  if (loading) {
    return <CircularProgress />;
  }

  if (!property) {
    return <Typography>Property not found</Typography>;
  }

  return (
    <div className="bg-gray-50">
      <PostLoginHeader />
      <main className="container mx-auto py-8 px-4">
        <Typography variant="h4">{property.name}</Typography>
        <Typography>Verified: {property.is_verified ? 'Yes' : 'No'}</Typography>

        <Button variant="contained" disabled={!property.is_verified}>Add Bed</Button>
        <Button variant="contained" disabled={!property.is_verified}>Add Room</Button>
      </main>
    </div>
  );
};

export default HostPropertyDetails;
